module.exports = __webpack_public_path__ + "static/media/man_coding.ce8a2dd2.jpg";